import type { Core, CourseDetail } from "./types";
import { buildIndex, type Index } from "./planner";

export interface Manifest { version: string; built: string; files: { core: string; desc?: string; details: Record<string, string> }; counts: Record<string, number> }

let manifestP: Promise<Manifest> | null = null;
export const loadManifest = () => (manifestP ??= fetch("/data/manifest.json", { cache: "no-cache" }).then((r) => r.json()));

let indexP: Promise<Index> | null = null;
type SlimSession = Core["sessions"][number] & { k?: string };

export function expandCore(core: Core): Core {
  const ay = core.calendar.academic_year;
  for (const s of core.sessions as SlimSession[]) {
    if (s.k !== undefined && !s.key) s.key = s.course_id + s.k;
    s.academic_year ??= ay;
    s.weeks ??= "every";
  }
  return core;
}

export const loadIndex = () => (indexP ??= loadManifest().then((m) => fetch(`/data/${m.files.core}`)).then((r) => r.json() as Promise<Core>).then((c) => buildIndex(expandCore(c))));

/** Merge course descriptions (shipped separately to keep the core small). */
export async function loadDescriptions(idx: Index): Promise<void> {
  const m = await loadManifest();
  if (!m.files.desc) return;
  const d: Record<string, string> = await fetch(`/data/${m.files.desc}`).then((r) => r.json());
  for (const [id, text] of Object.entries(d)) { const c = idx.courses.get(id); if (c) c.description = text; }
}

const details = new Map<string, Promise<Record<string, CourseDetail>>>();
export function loadDetails(unit: string): Promise<Record<string, CourseDetail>> {
  if (!details.has(unit)) details.set(unit, loadManifest().then((m) => (m.files.details[unit] ? fetch(`/data/${m.files.details[unit]}`).then((r) => r.json()) : {})));
  return details.get(unit)!;
}
